import React from 'react';
import Icon from '@components/@core/Icon';
import EditDropdown from '@components/EditDropdown';

const Packets = (props) => {
    return (
        <>
            <div className="d-flex border-bottom py-2">
                <div className="d-flex-5">
                    <span className="dsl-m12">Packets</span>
                </div>
                <div className="d-flex-2 text-end">
                    <span className="dsl-m12">Open</span>
                </div>
                <div className="d-flex-5 ms-2">
                    <span className="dsl-m12">Employees</span>
                </div>
                <div className="d-flex-2 text-end">
                    <span className="dsl-m12">Completed</span>
                </div>
                <div className="d-flex-5 ms-2">
                    <span className="dsl-m12">Employees</span>
                </div>
                <div className="d-flex-2" />
            </div>
            {[1, 2, 3].map((item, index) => (
                <div key={`p${index}`} className="d-flex align-items-center py-4 border-bottom">
                    <div className="d-flex-5 d-flex align-items-center">
                        <Icon name="fas fa-envelope-open-text" color="#343f4b" size={16} />
                        <span className="dsl-b14 ms-3">Name of packet...</span>
                    </div>
                    <div className="d-flex-2 text-end">
                        <span className="dsl-b14">{item}</span>
                    </div>
                    <div className="d-flex-5 ms-3">
                        <span className="dsl-b14">Jared Hamilton, Hiroki ...</span>
                    </div>
                    <div className="d-flex-2 text-end">
                        <span className="dsl-b14">{item}</span>
                    </div>
                    <div className="d-flex-5 ms-3">
                        <span className="dsl-b14">No Employee</span>
                    </div>
                    <div className="d-flex-2">
                        <EditDropdown />
                    </div>
                </div>
            ))}
        </>
    );
};

export default Packets;
